/* eslint-disable  */


import { Component } from 'react';

import { showErrorNotification } from '../../notifications';
import { addClickandPledgeurl } from '../actions';


type Props = {

/**
 * Invoked to obtain translated strings.
 */
t: Function,

/**
 * The URL of the Donorbox.
 */
_addUrldialog: Function,

/**
 * Dispatches a error notificatio
 */
_addErrorNotification: Function

};

/**
 * The click and Pledge function for both web and native.
 */
export default class AbstractclickAndPledge extends Component < Props > {
/**
 * Instantiates a new component.
 *
 *
 * @inheritdoc
 */
    constructor(props: Props) {
        super(props);
        this.state = {
            textc: null,
            url: false
        };
        this._onSubmitWeb = this._onSubmitWeb.bind(this);
        this._onSubmitNative = this._onSubmitNative.bind(this);
        this._urlExists = this._urlExists.bind(this);
    }


_urlExists: () => string;

/**
 * Url Await.
 *
 * @param {string} urll - The url value.
 * @returns {boolean} The url of the donorbox.
 */
_urlExists = async (urll: string) => {
    const myHeaders = new Headers();

    myHeaders.append('Cookie', 'ASP.NET_SessionId=qoz22zqp4vgf4gifcgl3sdi0; CnP_BB_FN_20200719=PAY106|YGRh4');
    const requestOptions = {
        method: 'GET',
        headers: myHeaders,
        redirect: 'follow',
        mode: 'no-cors'
    };
    const data = await fetch(urll, requestOptions);

    return data;
};

_onSubmitWeb: string => boolean;

/**
 * Submit the Form.
 *
 * @param {string} urll - The url value.
 * @returns {boolean} The url of the donorbox.
 */
 _onSubmitWeb = async () => {
     const url12 = this.state.textc;
     const p = /^(?:https?:\/\/)?(?:www\.)?(?:|connect\.clickandpledge\.com\/((\w|-))(?:\S+))?$/; 
     const q = /^(?:https?:\/\/)?(?:www\.)?(?:|connect\.clickandpledge\.com\/w\/Organization\/((\w|-))(?:\S+))?$/; 

     if (!this.state.textc.match(p) && !this.state.textc.match(q)) {

         this.setState({
             url: true
         });
         this.props._addErrorNotification({
             descriptionKey: 'clickandpledge.errorDesc',
             titleKey: 'clickandpledge.errorNotification'
         }, 5000);

         return false;
     }


     this.props._addUrldialog(url12);

     return true;
 }

     _onSubmitNative: string => boolean;

     /**
 * Submit the Form.
 *
 * @param {string} urll - The url value.
 * @returns {boolean} The url of the donorbox.
 */
 _onSubmitNative = async urll => {
    const url12 = this.state.textc;
    const p = /^(?:https?:\/\/)?(?:www\.)?(?:|connect\.clickandpledge\.com\/((\w|-))(?:\S+))?$/; 
     const q = /^(?:https?:\/\/)?(?:www\.)?(?:|connect\.clickandpledge\.com\/w\/Organization\/((\w|-))(?:\S+))?$/; 

    if (!urll.match(p) && !urll.match(q)) {

        this.setState({
            url: true
        });
        this.props._addErrorNotification({
            descriptionKey: 'clickandpledge.errorDesc',
            titleKey: 'clickandpledge.errorNotification'
        }, 5000);

        return false;
    }


    this.props._addUrldialog(urll);

    return true;
 }


}


/**
 * Redux _mapDispatchToProps .
 *
 * @param {number} dispatch - The Function.
 * @returns  {string} For the donorbox url.
 */
export function mapDispatchToProps(dispatch: Function): Object {
    return {
        _addUrldialog(url: string) {
            dispatch(addClickandPledgeurl(url));
        },
        _addErrorNotification(desc: Object) {
            dispatch(showErrorNotification(desc));
        }

    };
}
